import React, { useEffect, useRef } from 'react';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';

const RatingAgenciesTable = (props) => {
  const didMount = useRef(false);
  const {
    state,
    paginateRatingAgencies,
    itemsPerPageRatingAgencies,
    getRatingAgenciesByFilter,
  } = useLeagueTableContext();
  const { page, perPage } = state.ratingAgenciesCollection;

  const onPageChange = (page) => {
    paginateRatingAgencies(page.selected);
  };

  const onItemsPerPageChange = (perPage) => {
    itemsPerPageRatingAgencies(perPage.value);
  };

  useEffect(() => {
    if (didMount.current) {
      getRatingAgenciesByFilter();
    } else {
      didMount.current = true;
    }
  }, [page, perPage]);

  return (
    <LinkTable
      { ...props }
      { ...state.ratingAgenciesCollection }
      onPageChange={ onPageChange }
      onItemsPerPageChange={ onItemsPerPageChange }
    />
  );
};

export default RatingAgenciesTable;
